import merge from "deepmerge";

import base from "./base";

import App from "./App";
import AdminGbfsStream from "./components/Admin/GbfsStream";
import AdminLinkPayoutToKiwiliForm from "./components/Admin/LinkPayoutToKiwiliForm";
import AdminMailingListForm from "./components/Admin/MailingListForm";
import AdminPagination from "./components/Admin/Pagination";
import CommunityFriendsList from "./components/Community/CommunityFriendsList";
import CommunityProofForm from "./components/Community/ProofForm";
import CommunityUserDetails from "./components/Community/CommunityUserDetails";
import CommunityUsersList from "./components/Community/CommunityUsersList";
import DashboardBalance from "./components/Dashboard/Balance";
import DashboardLoanHistory from "./components/Dashboard/LoanHistory";
import DashboardResourcesList from "./components/Dashboard/ResourcesList";
import FormsDateRangePicker from "./components/Forms/DateRangePicker";
import FormsDurationInput from "./components/Forms/DurationInput";
import FormsFileUploader from "./components/Forms/FileUploader";
import FormsFilesUploader from "./components/Forms/FilesUploader";
import FormsImageUploader from "./components/Forms/ImageUploader";
import FormsImagesUploader from "./components/Forms/ImagesUploader";
import FormsQuerySelect from "./components/Forms/QuerySelect";
import FormsRelationInput from "./components/Forms/RelationInput";
import FormsValidatedInput from "./components/Forms/ValidatedInput";
import IncidentForm from "./components/Incident/IncidentForm";
import InvitationHeader from "./components/Invitation/InvitationHeader";
import LayoutFooter from "./components/Layout/Footer";
import LayoutNavbar from "./components/Layout/Navbar";
import LibraryForm from "./components/Library/Form";
import LoanBorrowerProfileWarning from "./components/Loan/BorrowerProfileWarning";
import LoanFullLoan from "./components/Loan/FullLoan";
import LoanAutoValidationBox from "./components/Loan/LoanAutoValidationBox";
import LoanButtons from "./components/Loan/LoanButtons";
import LoanDatesBox from "./components/Loan/LoanDatesBox";
import LoanFactorsBox from "./components/Loan/LoanFactorsBox";
import LoanIncidents from "./components/Incident/LoanIncidents";
import LoanInfoBox from "./components/Loan/InfoBox";
import LoanLoanableCalendar from "./components/Loan/LoanLoanableCalendar";
import LoanPaymentBox from "./components/Loan/LoanPaymentBox";
import LoanPriceSummary from "./components/Loan/LoanPriceSummary";
import LoanSimplePrice from "./components/Loan/SimplePrice";
import LoanNewLoanForm from "./components/Loan/NewLoanForm";
import LoanSearchForm from "./components/Loan/SearchForm";
import LoanStatusAlerts from "./components/Loan/Status/Alerts";
import LoanStatusBadge from "./components/Loan/Status/LoanStatusBadge";
import LoanableAvailabilityRules from "./components/Loanable/AvailabilityRules";
import LoanableAvailabilityStatus from "./components/Loanable/AvailabilityStatus";
import LoanableCalendarLegend from "./components/Loanable/CalendarLegend";
import LoanableDescriptionList from "./components/Loanable/DescriptionList";
import LoanableDetails from "./components/Loanable/Details";
import LoanableExceptions from "./components/Loanable/Exceptions";
import LoanableForm from "./components/Loanable/LoanableForm";
import LoanableInfoBox from "./components/Loanable/InfoBox";
import LoanableListActions from "./components/Loanable/LoanableListActions";
import LoanableEditPricingParameters from "./components/Loanable/LoanableEditPricingParameters";
import LoanableUserRoleForm from "./components/Loanable/UserRoleForm";
import LoanableUserRolesList from "./components/Loanable/UserRolesList";
import LoanableTypeSelection from "./components/Loanable/LoanableTypeSelection";
import LoanableList from "./components/Loanable/List";
import LoginBox from "./components/Login/Box";
import BankDetailsForm from "./components/PaymentMethod/BankDetailsForm";
import PaymentMethodForm from "./components/PaymentMethod/PaymentMethodForm";
import PricingForm from "./components/Pricing/PricingForm";
import ProfileForm from "./components/Profile/ProfileForm";
import RegisterForm from "./components/Register/RegisterForm";
import ActionsButton from "./components/shared/ActionsButton";
import DonationSlider from "./components/shared/DonationSlider";
import EmailNotVerifiedAlert from "./components/shared/EmailNotVerifiedAlert";
import FileDownloadLink from "./components/shared/FileDownloadLink";
import MarkdownContent from "./components/shared/MarkdownContent";
import MarkdownEditor from "./components/shared/MarkdownEditor";
import PaginatedTable from "./components/shared/PaginatedTable";
import UserComment from "./components/shared/UserComment";
import UserAddCreditBox from "./components/User/AddCreditBox";
import UserClaimCreditsBox from "./components/User/ClaimCreditsBox";
import UserEmailForm from "./components/User/EmailForm";
import UserPasswordForm from "./components/User/PasswordForm";
import UserPaymentDialog from "./components/User/PaymentDialog";
import UserProvisionModal from "./components/User/ProvisionModal";
import UserIdentityProofInput from "./components/User/IdentityProofInput";
import UserResidencyProofInput from "./components/User/ResidencyProofInput";
import VeeValidate from "./vee-validate";
import HelpersInvoices from "./helpers/invoices";
import bikes from "./models/bikes";
import bill_items from "./models/bill_items";
import borrowers from "./models/borrowers";
import cars from "./models/cars";
import car_trailers from "./models/car_trailers";
import communities from "./models/communities";
import incidents from "./models/incidents";
import invoices from "./models/invoices";
import libraries from "./models/libraries";
import loanables from "./models/loanables";
import loans from "./models/loans";
import mailing_lists from "./models/mailing_lists";
import paymentMethods from "./models/paymentMethods";
import pricings from "./models/pricings";
import trailers from "./models/trailers";
import users from "./models/users";
import user_roles from "./models/user_roles";

import FileRequests from "./requests/fileRequests";
import InvitationRequests from "./requests/invitationRequests";
import LoanableUserRolesRequests from "./requests/loanableUserRolesRequests";
import LoanRequests from "./requests/loanRequests";
import ServerRequests from "./requests/server";

import StoreAccount from "./store/account";
import StoreInvitation from "./store/invitation";
import StoreCommunities from "./store/models/communities";
import StoreLoanables from "./store/models/loanables";
import StoreLoanableSearch from "./store/pages/loanable/search";
import StoreUsers from "./store/models/users";
import StoreDashboard from "./store/pages/dashboard";
import StorePassword from "./store/password";
import StoreRestModule from "./store/RestModule";

import AcceptInvitation from "./views/AcceptInvitation";
import AdminCommunities from "./views/admin/Communities";
import AdminCommunity from "./views/admin/Community";
import AdminDashboard from "./views/admin/Dashboard";
import AdminGbfsDataset from "./views/admin/GbfsDataset";
import AdminGbfsDatasets from "./views/admin/GbfsDatasets";
import AdminInvitation from "./views/admin/Invitation";
import AdminInvitations from "./views/admin/Invitations";
import AdminInvoice from "./views/admin/Invoice";
import AdminInvoices from "./views/admin/Invoices";
import AdminLibraries from "./views/admin/Libraries";
import AdminLoanable from "./views/admin/Loanable";
import AdminLoanables from "./views/admin/Loanables";
import AdminLoans from "./views/admin/Loans";
import AdminMailingLists from "./views/admin/AdminMailingLists";
import AdminPayouts from "./views/admin/Payouts";
import AdminReports from "./views/admin/AdminReports";
import AdminUser from "./views/admin/User";
import AdminUsers from "./views/admin/Users";
import AdminYearlyIncomeReportsBox from "./views/admin/YearlyIncomeReportsBox";
import CommunityOverview from "./views/community/Overview";
import CommunityOverviewCard from "./views/community/CommunityOverviewCard";
import Conditions from "./views/Conditions";
import Dashboard from "./views/Dashboard";
import LoanableSearch from "./views/loanable/Search";
import NotFound from "./views/NotFound";
import PasswordRequest from "./views/password/Request";
import PasswordReset from "./views/password/Reset";
import AccountProfile from "./views/profile/Account";
import ProfileBorrower from "./views/profile/Borrower";
import ProfileCommunities from "./views/profile/Communities";
import ProfileCommunity from "./views/profile/Community";
import ProfileCommunitySubscriptions from "./views/profile/CommunitySubscriptions";
import ProfileLibraryLoanableOverview from "./views/profile/LibraryLoanableOverview";
import ProfileLibraryOverview from "./views/profile/LibraryOverview";
import ProfileLoanables from "./views/profile/Loanables";
import ProfileLoanableOverview from "./views/profile/LoanableOverview";
import ProfileLoans from "./views/profile/Loans";
import ProfileInvoices from "./views/profile/Invoices";
import ProfileLocomotion from "./views/profile/Locomotion";
import ProfilePaymentMethod from "./views/profile/PaymentMethod";
import ProfileReports from "./views/profile/Reports";
import RegisterStep from "./views/register/Step";

const messages = merge.all([
  App,
  base,

  // Models
  bikes,
  bill_items,
  borrowers,
  cars,
  car_trailers,
  communities,
  incidents,
  invoices,
  libraries,
  loans,
  loanables,
  mailing_lists,
  paymentMethods,
  pricings,
  trailers,
  users,
  user_roles,

  // Components
  ActionsButton,
  AdminGbfsStream,
  AdminLinkPayoutToKiwiliForm,
  AdminMailingListForm,
  AdminPagination,
  BankDetailsForm,
  CommunityFriendsList,
  CommunityProofForm,
  CommunityUserDetails,
  CommunityUsersList,
  DashboardBalance,
  DashboardLoanHistory,
  DashboardResourcesList,
  DonationSlider,
  EmailNotVerifiedAlert,
  FileDownloadLink,
  FormsDateRangePicker,
  FormsDurationInput,
  FormsFileUploader,
  FormsFilesUploader,
  FormsImageUploader,
  FormsImagesUploader,
  FormsQuerySelect,
  FormsRelationInput,
  FormsValidatedInput,
  IncidentForm,
  InvitationHeader,
  LayoutFooter,
  LayoutNavbar,
  LibraryForm,
  LoanAutoValidationBox,
  LoanBorrowerProfileWarning,
  LoanButtons,
  LoanDatesBox,
  LoanFactorsBox,
  LoanFullLoan,
  LoanIncidents,
  LoanInfoBox,
  LoanLoanableCalendar,
  LoanNewLoanForm,
  LoanPaymentBox,
  LoanPriceSummary,
  LoanSimplePrice,
  LoanSearchForm,
  LoanStatusAlerts,
  LoanStatusBadge,
  LoanableAvailabilityRules,
  LoanableAvailabilityStatus,
  LoanableCalendarLegend,
  LoanableDescriptionList,
  LoanableDetails,
  LoanableExceptions,
  LoanableForm,
  LoanableInfoBox,
  LoanableListActions,
  LoanableEditPricingParameters,
  LoanableUserRoleForm,
  LoanableUserRolesList,
  LoanableTypeSelection,
  LoanableList,
  LoginBox,
  MarkdownContent,
  MarkdownEditor,
  PaginatedTable,
  PaymentMethodForm,
  PricingForm,
  ProfileForm,
  RegisterForm,
  UserAddCreditBox,
  UserClaimCreditsBox,
  UserComment,
  UserIdentityProofInput,
  UserResidencyProofInput,
  UserEmailForm,
  UserPasswordForm,
  UserPaymentDialog,
  UserProvisionModal,
  VeeValidate,

  // Helpers
  HelpersInvoices,

  // Requests
  FileRequests,
  InvitationRequests,
  LoanableUserRolesRequests,
  LoanRequests,
  ServerRequests,

  // Store
  StoreAccount,
  StoreInvitation,
  StoreCommunities,
  StoreLoanables,
  StoreLoanableSearch,
  StoreUsers,
  StoreDashboard,
  StorePassword,
  StoreRestModule,

  // Views
  AcceptInvitation,
  AdminCommunities,
  AdminCommunity,
  AdminDashboard,
  AdminGbfsDataset,
  AdminGbfsDatasets,
  AdminInvitation,
  AdminInvitations,
  AdminInvoice,
  AdminInvoices,
  AdminLibraries,
  AdminLoanable,
  AdminLoanables,
  AdminLoans,
  AdminMailingLists,
  AdminPayouts,
  AdminReports,
  AdminUser,
  AdminUsers,
  AdminYearlyIncomeReportsBox,
  CommunityOverview,
  CommunityOverviewCard,
  Conditions,
  Dashboard,
  LoanableSearch,
  NotFound,
  AccountProfile,
  PasswordRequest,
  PasswordReset,
  ProfileBorrower,
  ProfileCommunities,
  ProfileCommunity,
  ProfileCommunitySubscriptions,
  ProfileLibraryLoanableOverview,
  ProfileLibraryOverview,
  ProfileLoanables,
  ProfileLoanableOverview,
  ProfileLoans,
  ProfileInvoices,
  ProfileLocomotion,
  ProfilePaymentMethod,
  ProfileReports,
  RegisterStep,
]);

export default messages;
